// Intent: [Branding] [Trust] [SEO/GEO]
import React from "react";
import { AUSTEN_EMAIL, PORTAL_LOGIN_URL, PORTAL_REGISTER_URL, SITE_NAVIGATION } from "../../config";
import { BrandLogo } from "../shared/BrandLogo";
const categories = ["Kitchen Cabinets", "Laundry Cabinets", "Wardrobes & Storage", "Bathroom Vanities", "Doors & Panels", "Hardware & Extras"];
const audiences = [{
  label: "Trades & Installers",
  href: "/who-we-help/#trades"
}, {
  label: "Builders",
  href: "/who-we-help/#builders"
}, {
  label: "DIY Renovators",
  href: "/who-we-help/#diy"
}];
function Footer() {
  return <footer className="bg-pfpc-navy pb-24 pt-14 text-pfpc-offwhite md:pb-8 md:pt-20" data-id="element-55" data-mp="3n3k9u6dm4nqe">
      <div className="container-shell" data-id="element-56" data-mp="3n17um0z8orh1">
        <div className="grid gap-12 border-b border-pfpc-offwhite/15 pb-14 lg:grid-cols-[1.15fr_2fr] lg:gap-16" data-id="element-57" data-mp="3j2rztawx2et2">
          <div data-id="element-58" data-mp="3e1ulxaixw6xd">
            <BrandLogo size="footer" className="ring-4 ring-pfpc-offwhite" data-id="element-59" data-mp="3e2cqcufr9rgd" />
            <p className="mt-7 max-w-sm text-[16px] leading-7 text-pfpc-offwhite/70" data-id="element-60" data-mp="394udwu2j4u3m">Online cabinetry ordering for Perth trades, builders and capable DIY renovators.</p>
            <a href={`mailto:${AUSTEN_EMAIL}`} className="mt-5 inline-block text-[15px] font-bold text-pfpc-offwhite underline decoration-pfpc-orange underline-offset-4 hover:text-pfpc-orange" data-id="element-61" data-mp="2p3l1yiph5c0s">
              {AUSTEN_EMAIL}
            </a>
            {/* Phone, address, ABN and opening hours intentionally omitted until verified. */}
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3" data-id="element-62" data-mp="341lr8tvukply">
            <FooterGroup title="Navigate" links={SITE_NAVIGATION.map(item => ({
            label: item.label,
            href: item.href
          }))} data-id="element-63" data-mp="382z0ldy5faxm" />
            <FooterGroup title="Cabinetry" links={categories.map(label => ({
            label,
            href: "/cabinetry/"
          }))} data-id="element-64" data-mp="2u24qmqvgd1wu" />
            <div className="col-span-2 sm:col-span-1" data-id="element-65" data-mp="2z067d55eop55">
              <FooterGroup title="Who we help" links={audiences} data-id="element-66" data-mp="1inhouwsxi5rh" />
              <div className="mt-6 flex flex-col gap-3 text-[15px]" data-id="element-67" data-mp="1iq3silcp814f">
                <a href={PORTAL_REGISTER_URL} className="font-bold text-pfpc-orange hover:underline" data-id="element-68" data-mp="1nof1yuz309m4">Start designing online</a>
                <a href={PORTAL_LOGIN_URL} className="font-bold text-pfpc-offwhite hover:underline" data-id="element-69" data-mp="13mk9ye6popvt">Return to your job</a>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-5 pt-7 text-[14px] leading-6 text-pfpc-offwhite/65 lg:flex-row lg:items-center lg:justify-between" data-id="element-70" data-mp="uqb8yv335j7k">
          <p data-id="element-71" data-mp="kurjorj11irs">© {new Date().getFullYear()} Perth Flat Pack Cabinets. All rights reserved.</p>
          <p data-verify="legal-policies" className="max-w-2xl lg:text-right" data-id="element-72" data-mp="funbrpw6pwd6">Ordering policy topics: privacy, terms, returns and changes, delivery and accessibility.</p>
        </div>
      </div>
    </footer>;
}
type FooterGroupProps = {
  title: string;
  links: ReadonlyArray<{
    label: string;
    href: string;
  }>;
};
function FooterGroup({
  title,
  links
}: FooterGroupProps) {
  return <div data-id="element-73" data-mp="218hwqns4jhdk">
      <h2 className="section-label mb-5 text-pfpc-orange" data-id="element-74" data-mp="218rh9vuegwbv">{title}</h2>
      <ul className="space-y-3" data-id="element-75" data-mp="216f2frjxv231">
        {links.map(link => <li key={link.label} data-id="element-76" data-mp="28r7q55ujj1r8"><a href={link.href} className="text-[15px] leading-6 text-pfpc-offwhite/72 transition hover:text-pfpc-offwhite hover:underline" data-id="element-77" data-mp="28rqzhy64khtn">{link.label}</a></li>)}
      </ul>
    </div>;
}
export { Footer };